import {
  LOADING_RIESGOS,
  LOAD_RIESGOS,
  ERROR_RIESGOS,
  LOADING_COMPROMISOS,
  LOAD_COMPROMISOS,
  ERROR_COMPROMISOS,
  LOADING_NOVEDADES,
  LOAD_NOVEDADES,
  ERROR_NOVEDADES,
  LOADING_APRENDIZAJES,
  LOAD_APRENDIZAJES,
  ERROR_APRENDIZAJES,
  LOADING_RETROSPECTIVAS,
  LOAD_RETROSPECTIVAS,
  ERROR_RETROSPECTIVAS,
} from "./briefcaseArtifactsTypes";
import {
  RiesgosServices,
  CompromisosServices,
  NovedadesServices,
  AprendizajesServices,
  RetrospectivasServices,
} from "../../components/Briefcase/BriefcaseServices";

// Fábrica de thunk de fetch DRY: una por matriz. El service devuelve el array (vacío si el portafolio
// es de otra org, CA-12); el componente nunca distingue "no existe" de "ajeno".
const buildFetch = (service, loadingType, loadType, errorType) => (idPortafolio) => {
  return (dispatch) => {
    dispatch({ type: loadingType });
    service
      .list(idPortafolio)
      .then((data) => dispatch({ type: loadType, payload: data }))
      .catch(() => dispatch({ type: errorType }));
  };
};

export const fetchRiesgos = buildFetch(
  RiesgosServices,
  LOADING_RIESGOS,
  LOAD_RIESGOS,
  ERROR_RIESGOS
);
export const fetchCompromisos = buildFetch(
  CompromisosServices,
  LOADING_COMPROMISOS,
  LOAD_COMPROMISOS,
  ERROR_COMPROMISOS
);
export const fetchNovedades = buildFetch(
  NovedadesServices,
  LOADING_NOVEDADES,
  LOAD_NOVEDADES,
  ERROR_NOVEDADES
);
export const fetchAprendizajes = buildFetch(
  AprendizajesServices,
  LOADING_APRENDIZAJES,
  LOAD_APRENDIZAJES,
  ERROR_APRENDIZAJES
);
export const fetchRetrospectivas = buildFetch(
  RetrospectivasServices,
  LOADING_RETROSPECTIVAS,
  LOAD_RETROSPECTIVAS,
  ERROR_RETROSPECTIVAS
);
